<template>
    <div>
        <div class="info-box">
            <courseinfo ref="courseinfo" :intoType='intoType' :intoCourseId='this.$route.query.courseId'></courseinfo>
        </div>
        <div class="info-box">
            <div class="info-title">
                <h3>课程考试(试卷)质量检查评价表</h3>
                <p></p>
            </div>
            <div class="info-main">
                <div class="table">
                    <a-table
                        :columns="columns"
                        :data-source="data"
                        bordered
                        size="middle"
                        :pagination="{ defaultPageSize	: 20,hideOnSinglePage:true}">
                    <template
                        v-for="col in ['indexScore']"
                        :slot="col"
                        slot-scope="text, record, index"
                        >
                        <div :key="col">
                            <a-input
                            v-if="true"
                            style="margin: -5px 0"
                            :value="text"
                            @change="e => handleChange(e.target.value, record.indexId, col)"
                            />
                            <template v-else>
                            {{ text }}
                            </template>
                        </div>
                        </template>


                    </a-table>
                </div>
            </div>
        </div>
        <div class="info-box">
            <div class="info-title">
                <h3>综合评语</h3>
                <p></p>
            </div>
            <div class="info-main">      
                <div class="input-box input-box-center">
                    <p>评语：</p>
                    <a-textarea class="input" v-model="info.compComments" :rows="4"/>
                </div>
            </div>
        </div>
        <div class="btn-box">
            <a-button type="primary" v-if="type!='look'" @click="sub">提交</a-button>
            <a-button @click="$router.go(-1)">取消</a-button>
        </div>
    </div>
</template>
<script>
    import { add,update,info } from '@/baseAPI/undergraduate/culture/spotCheck'
    import courseinfo from '../culture/courseInfo'

    const columns = [

        {
            title: '观测指标',
            dataIndex: 'indexPid',
            width: 50,
            fixed: 'left',
            align:'center',
            colSpan:2,
            customRender: (value, row, index) => {
                const obj = {
                    children: value,
                    attrs: {},
                };
                if (index === 0) {
                    obj.attrs.rowSpan = 4;
                }
                // These two are merged into above cell
                if (index === 1 || index === 2|| index === 3) {
                    obj.attrs.rowSpan = 0;
                }
                if (index === 4) {
                    obj.attrs.rowSpan = 5;
                }
                if (index === 5 || index === 6|| index === 7|| index === 8) {
                    obj.attrs.rowSpan = 0;
                }
                if (index === 9) {
                    obj.attrs.rowSpan = 3;
                }
                if (index === 10 || index === 11) {
                    obj.attrs.rowSpan = 0;
                }
                if(index == 12){
                    obj.attrs.colSpan = 2;
                }
                return obj;
            },
        },
        {
            title: '观测指标',
            dataIndex: 'indexPname',
            width: 200,
            fixed: 'left',
            align:'center',
            colSpan:0,
            customRender: (value, row, index) => {
                const obj = {
                    children: value,
                    attrs: {},
                };
                if (index === 0) {
                    obj.attrs.rowSpan = 4;
                }
                // These two are merged into above cell
                if (index === 1 || index === 2|| index === 3) {
                    obj.attrs.rowSpan = 0;
                }
                if (index === 4) {
                    obj.attrs.rowSpan = 5;
                }
                if (index === 5 || index === 6|| index === 7|| index === 8) {
                    obj.attrs.rowSpan = 0;
                }
                if (index === 9) {
                    obj.attrs.rowSpan = 3;
                }
                if (index === 10 || index === 11) {
                    obj.attrs.rowSpan = 0;
                }
                if(index == 12){
                    obj.attrs.colSpan = 0;
                }
                return obj;
            },
        },
        {
            title: '评价指标',
            dataIndex:'indexId',
            width: 100,
            colSpan:2,
            align:'center',
            customRender: (value, row, index) => {
                const obj = {
                    children: value,
                    attrs: {},
                };
                if(index == 12){
                    obj.attrs.colSpan = 0;
                }
                return obj;
            }
        },
        {
            title: '评价指标',
            dataIndex:'indexContent',
            width: 700,
            colSpan:0,
            customRender: (value, row, index) => {
                const obj = {
                    children: value,
                    attrs: {},
                };
                if(index == 12){
                    obj.attrs.colSpan = 2;
                }
                return obj;
            }
        },
        {
            title: '分值',
            dataIndex:'indexFullScore',
            width: 100,
            align:'center',
            customRender: (value, row, index) => {
                const obj = {
                    children: value,
                    attrs: {},
                };
                // if (index === 9) {
                //     obj.attrs.rowSpan = 3;
                // }
                // if (index === 10 || index === 11) {
                //     obj.attrs.rowSpan = 0;
                // }
                return obj;
            },
        },
        {
            title: '得分',
            dataIndex: 'indexScore',
            width: 100,
            fixed: 'right',
            align:'center',
            scopedSlots: { customRender: 'indexScore' },
        },
        ]
    const data = [
        {   
            indexPid:'I',
            indexPname:"命题规范性与质量(35%)",
            indexId:'1',
            indexContent:"使用院校统一试卷样式，试卷文字、图表等印制规范无错误，有A、B卷(A、B卷相同试题分值比例低于30%)",
            indexFullScore:"5",
            indexScore:""
        },
        {   
            indexPid:'I',
            indexPname:"命题规范性与质量(35%)",
            indexId:'2',
            indexContent:"命题符合教学大纲或教学基本要求，题意表述确切无歧义，无学术性错误",
            indexFullScore:"10",
            indexScore:""
        },
        {   
            indexPid:'I',
            indexPname:"命题规范性与质量(35%)",
            indexId:'3',
            indexContent:"试卷题型设置与分值分配合理，大、小题分值标注明晰",
            indexFullScore:"10",
            indexScore:""
        },
        {   
            indexPid:'I',
            indexPname:"命题规范性与质量(35%)",
            indexId:'4',
            indexContent:"试卷内容覆盖面适当， 题量适中，难易度、区分度好",
            indexFullScore:"10",
            indexScore:""
        },
        {   
            indexPid:'II',
            indexPname:"批阅规范性与质量(50%)",
            indexId:'5',
            indexContent:"评分标准科学合理，参考答案完整无误(注:B 卷不启用无需提交参考答案)",
            indexFullScore:"10",
            indexScore:""
        },
        {   
            indexPid:'II',
            indexPname:"批阅规范性与质量(50%)",
            indexId:'6',
            indexContent:"红笔阅卷，批阅过程清晰可辨，赋分方式统一",
            indexFullScore:"10",
            indexScore:""
        },
        {   
            indexPid:'II',
            indexPname:"批阅规范性与质量(50%)",
            indexId:'7',
            indexContent:"试卷批阅中无错批、漏批现象，无随意拉分、扣分现象",
            indexFullScore:"10",
            indexScore:""
        },
        {   
            indexPid:'II',
            indexPname:"批阅规范性与质量(50%)",
            indexId:'8',
            indexContent:"成绩统计分、登录分正确，无错登、漏登现象",
            indexFullScore:"10",
            indexScore:""
        },
        {   
            indexPid:'II',
            indexPname:"批阅规范性与质量(50%)",
            indexId:'9',
            indexContent:"课程成绩分布合理，考试成绩分布状态与试卷难易度吻合度好",
            indexFullScore:"10",
            indexScore:""
        },
        {   
            indexPid:'III',
            indexPname:"文档规范(15%)",
            indexId:'10',
            indexContent:"平时成绩评定佐证材料完整、规范",
            indexFullScore:"5",
            indexScore:""
        },
        {   
            indexPid:'III',
            indexPname:"文档规范(15%)",
            indexId:'11',
            indexContent:"教学进度表、成绩登录表和教学情况总结表等填写完整、无缺项",
            indexFullScore:"5",
            indexScore:""
        },
        {   
            indexPid:'III',
            indexPname:"文档规范(15%)",
            indexId:'12',
            indexContent:"符合院系规定的课程考试归档材料要求",
            indexFullScore:"5",
            indexScore:""
        }
        ,
        {   
            indexPid:'总分(百分制)',
            indexPname:"",
            indexId:'13',
            indexContent:"",
            indexFullScore:"100",
            indexScore:""
        }
    ]

    export default {
        name: '',
        components: {
            courseinfo
        },
        data () {
            return {
                type:'',
                info:{
                    id:'',
                    courseInfoId: '',
	                reviewer: '',
	                totalScore: '',
	                compComments: '',
                    evaluateDate:'',
                    list:[]
                },
                intoType:'into',
                intoCourseId:'',
                source:'',
                columns,
                data
            }
        },
        mounted () {
            this.type=this.$route.query.type;
            this.source=this.$route.query.source;
            this.info.id=this.$route.query.id;
            if(this.type=='add'){

            }else{
                setTimeout(()=>{
                    info(this.$route.query.courseId).then(res=>{
                        this.info=res.data;
                        this.data = this.info.list
                    })
                },500)
            }
            this.info.courseInfoId=this.$route.query.courseId
            this.info.reviewer=this.$store.state.user.userId
        },
        methods:{
            formatDate (date) {
                let myyear = date.getFullYear();
                let mymonth = date.getMonth() + 1;
                let myweekday = date.getDate();
                let myHour = date.getHours();
                let myMin = date.getMinutes();
                let mySec = date.getSeconds();

                if (mymonth < 10) {
                    mymonth = '0' + mymonth;
                }
                if (myweekday < 10) {
                    myweekday = '0' + myweekday;
                }
                if (myHour < 10) {
                    myHour = '0' + myHour;
                }
                if (myMin < 10) {
                    myMin = '0' + myMin;
                }
                if (mySec < 10) {
                    mySec = '0' + mySec;
                }
                return (myyear + '-' + mymonth + '-' + myweekday + ' ' + myHour + ':' + myMin + ':' + mySec);
            },
            handleChange(value, key, column) {                
                const newData = [...this.data];
                const target = newData.filter(item => key === item.indexId)[0];
                
                if (target) {
                    target[column] = value;
                    this.data = newData;
                }
                this.info.totalScore = 0
                this.data.forEach((item,index)=>{
                    if(item.indexScore != '' && index < 12){
                        this.info.totalScore += parseInt(item.indexScore)
                    }
                })
                this.data[12].indexScore = this.info.totalScore 

            },
            onChange(e){
                this.info.tysj = e.target.value
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            sub(){
                var isSub=true;
                var arr=['courseInfoId']
                for(let i=0;i<arr.length;i++){
                    if(this.info[arr[i]]==null||this.info[arr[i]]===''){
                        isSub=false;
                        
                        break;
                    }
                }
                if(isSub){
                    this.info.evaluateDate=this.formatDate(new Date())
                    this.info.list=this.data
                    
                    if(this.type=='add'){
                        add(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'新增试卷抽查成功',
                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }else{
                        update(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'修改试卷抽查成功',
                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }
                }else{
                    this.$notification['warning']({
                        message: '警告',
                        description:'请填写完整！',
                    });
                }
            }
        }
    }
</script>
<style scoped>
    .info-box{
        margin-bottom: 2rem;
    }
    .info-title{
        position: relative;
        line-height: 3rem;
    }
    .info-title h3{
        font-size: 1.2rem;
        font-weight: bold;
        letter-spacing: 2px;
        padding-left: 10px;
        color: #245086;
    }
    .info-title p{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 50%;
        height: 3px;
        background-image: linear-gradient(to right, #245086 , rgba(36,80,134,0));
    }
    .info-title .ant-btn{
        float: right;
        margin-top: calc(1.5rem - 16px);
        margin-right: 2rem;
    }
    .info-main{
        display: flex;
        flex-wrap: wrap;
        margin-top: 1.5rem;
    }

    .info-main .table{
        margin-left: 10rem;
    }
    .info-main .input-box{
        width: 33%;
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
        position: relative;
    }
    .info-main .input-box-center{
        width: 66%;
    }
    .info-main .input-box p{
        width: 10rem;
        text-align: right;
    }
    .info-main .input-box .input{
        width: calc(100% - 10rem);
    }
    .info-main .input-box .radio{
        width: calc(100% - 10rem);
    }
    .info-main .input-box .tips{
        width: calc(100% - 11rem);
        position: absolute;
        right: 0;
        top: 100%;
        font-size: 13px;
        line-height: 20px;
        color: #1890ff;
    }
    .ant-table-wrapper{
        margin-top: 2rem;
    }
    .ant-table-wrapper >>> .ant-empty-normal{
        display: none;
    }
    .text-box{
        display: flex;
        margin-bottom: 0.5rem;
    }
    .text-box p{
        font-size: 1rem;
        line-height: 2rem;
    }
    .text-box .title{
        width: 5rem;
        text-align: right;
    }
    .text-box .text{
        border: 1px solid #ccc;
        padding: 0 10px;
        border-radius: 5px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 10px;
    }
    .ant-table-wrapper .input-box{
        width: 100%;
    }
    .btn-box{
        text-align: center;
    }
    .btn-box .ant-btn{
        margin: 0 1rem;
    }
    .input >>> .ant-input[disabled],
    .ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }
    .standard{
        width: 28px;
        height: 100px;
        position: absolute;
        right: 0;
        top: 200px;
        text-align: center;
        border-radius: 6px 0 0 6px !important;
        z-index: 0;
        pointer-events: auto;
        cursor: pointer;
        color: rgb(255, 255, 255);
        background-color: #245086;
        opacity: 0.8;
        padding: 2px 0px 0px 0px;
    }

    .standard:hover{
        opacity: 1;
    }

    .info-main .input-maxbox{
        width: 99%;
        display: flex;
        line-height: 32px;
        position: relative;
    }

    .info-main .input-maxbox p{
        width: 10rem;
        text-align: right;
    }

    .info-main .input-maxbox .textarea{
        width: calc(100% - 10rem);
    }

    .info-main .input-notes{
        width: 99%;
        display: flex;
        line-height: 32px;
        position: relative;
    }

    .info-main .input-notes .notes{
        width: calc(100% - 10rem);
        text-align: left;
        font-size: 0.9rem;
    }

    .info-main .input-notes .note-title{
        width: 10rem;
        text-align: right;
        font-size: 0.9rem;
        font-weight: bolder;
        color: black;
    }

</style>
